import { IAddressSearchInfo } from "./addressSearchInfo.types";

export class AddressSearchInfo implements IAddressSearchInfo {
  zipNo: string;
  dongAddress: string;
  dongNo: string;
  roadAddress: string;
  roadNo: string;
  isUnder: boolean;
  buildingMainNo: number;
  buildingSubNo: number;

  constructor(data: IAddressSearchInfo) {
    this.zipNo = data.zipNo;
    this.dongAddress = data.dongAddress;
    this.dongNo = data.dongNo;
    this.roadAddress = data.roadAddress;
    this.roadNo = data.roadNo;
    this.isUnder = data.isUnder;
    this.buildingMainNo = data.buildingMainNo;
    this.buildingSubNo = data.buildingSubNo;
  }
}
